import noodleApiClient from '@/tsClient/servers/noodleApi';

/** A single field in the case data schema with its path and value type. */
type CaseDataSchemaField = {
  fieldPath: string;
  type: 'date' | 'number' | 'string';
};

/** Response from the case data schema endpoint. */
type CaseDataSchemaResponse = {
  fields: CaseDataSchemaField[];
  version: number;
};

/** Fetches the case data schema (field paths and their types). */
const getCaseDataSchema = async (): Promise<CaseDataSchemaResponse> => {
  const response = await noodleApiClient.get('/cases/schema');
  return response.data as CaseDataSchemaResponse;
};

export type { CaseDataSchemaField, CaseDataSchemaResponse };
export default getCaseDataSchema;
